import { createRouter, createWebHistory } from "vue-router";
import ConfiguracoesLayoutBase from "@/ui/layout/ConfiguracoesLayoutBase.vue";
import { Settings } from "lucide-vue-next";
import { useGlobalStore } from "@/store/useGlobalStore";
import carregarDadosDoMenu from "@/middlewares/carregarDadosDoMenu";

// Import direto, sem children separados:
const routes = [
  {
    path: "/",
    redirect: () => {
      const store = useGlobalStore();
      return store.cnpjLogado ? "/inicio" : "/login";
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/pages/LoginPage.vue"),
    meta: { menu: false },
  },
  {
    path: "/recuperar-senha",
    name: "RecuperarSenha",
    component: () => import("@/pages/RecuperarSenhaPage.vue"),
    meta: { menu: false, public: true },
  },
  {
    path: "/cadastro",
    name: "Cadastro",
    component: () => import("@/pages/CadastroPage.vue"),
    meta: { menu: false, public: true },
  },
  {
    path: "/cadastro/sucesso",
    name: "CadastroSucesso",
    component: () => import("@/pages/CadastroSucessoPage.vue"),
    meta: { menu: false, public: true },
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: () => import("@/pages/OnboardingPage.vue"),
    meta: { menu: false },
  },
  {
    path: "/planos",
    name: "Planos",
    component: () => import("@/pages/PlanosPage.vue"),
    meta: { menu: false, public: true },
  },
  {
    path: "/comparar",
    name: "Comparacao",
    component: () => import("@/pages/ComparacaoPage.vue"),
    meta: { menu: false, public: true },
  },
  {
    path: "/relatorios-avancados",
    name: "RelatoriosAvancados",
    component: () => import("@/pages/RelatoriosAvancadosPage.vue"),
    meta: {
      menu: true,
      label: "Relatórios Avançados",
      funcionalidade: "relatorios_avancados",
    },
  },
  {
    path: "/inicio",
    name: "Inicio",
    component: () => import("@/pages/DashboardPage.vue"),
    meta: {
      menu: true,
      label: "Início",
      icon: "Home",
      grupo: "principal",
      funcionalidade: "dashboard",
    },
  },
  {
    path: "/agenda",
    name: "Agenda",
    component: () => import("@/pages/AgendaPage.vue"),
    meta: {
      menu: true,
      label: "Agenda",
      icon: "Calendar",
      grupo: "principal",
      funcionalidade: "agendamento",
    },
  },
  {
    path: "/confirmacao-agendamento",
    name: "ConfirmacaoAgendamento",
    component: () => import("@/pages/ConfirmacaoAgendamentoPage.vue"),
    meta: {
      menu: true,
      label: "Confirmações",
      icon: "CheckCircle",
      grupo: "principal",
      funcionalidade: "confirmacao_agendamento",
    },
  },
  {
    path: "/acompanhamento-atendimento",
    name: "AcompanhamentoAtendimento",
    component: () => import("@/pages/AcompanhamentoAtendimentoPage.vue"),
    meta: {
      menu: true,
      label: "Atendimento",
      icon: "Activity",
      grupo: "principal",
      funcionalidade: "acompanhamento_atendimento",
    },
  },
  {
    path: "/pdv",
    name: "Pdv",
    component: () => import("@/pages/PdvPage.vue"),
    meta: {
      menu: true,
      label: "PDV",
      icon: "ShoppingCart",
      grupo: "principal",
      funcionalidade: "pdv",
    },
  },
  // 🐾 Grupo Clientes
  {
    path: "/historico",
    name: "Historico",
    component: () => import("@/pages/HistoricoPage.vue"),
    meta: {
      menu: true,
      label: "Histórico",
      icon: "ClipboardList",
      grupo: "clientes",
      funcionalidade: "historico",
    },
  },
  {
    path: "/avaliacoes",
    name: "Avaliacoes",
    component: () => import("@/pages/AvaliacoesPage.vue"),
    meta: {
      menu: true,
      label: "Avaliações",
      icon: "Star",
      grupo: "clientes",
      funcionalidade: "avaliacoes",
    },
  },
  {
    path: "/fidelidade",
    name: "Fidelidade",
    component: () => import("@/pages/FidelidadePage.vue"),
    meta: {
      menu: true,
      label: "Fidelidade",
      icon: "Gift",
      grupo: "clientes",
      funcionalidade: "fidelidade",
    },
  },
  {
    path: "/notificacoes",
    name: "Notificacoes",
    component: () => import("@/pages/NotificacoesPage.vue"),
    meta: {
      menu: true,
      label: "Notificações",
      icon: "Send",
      grupo: "clientes",
      funcionalidade: "notificacoes_personalizadas",
    },
  },
  // 📦 Grupo Gestão
  {
    path: "/funcionarios",
    name: "Funcionarios",
    component: () => import("@/pages/FuncionariosPage.vue"),
    meta: {
      menu: true,
      label: "Funcionários",
      icon: "Users",
      grupo: "gestao",
      funcionalidade: "funcionarios",
    },
  },
  {
    path: "/relatorios",
    name: "Relatorios",
    component: () => import("@/pages/RelatoriosPage.vue"),
    meta: {
      menu: true,
      label: "Relatórios",
      icon: "BarChart2",
      grupo: "gestao",
      funcionalidade: "relatorios",
    },
  },
  {
    path: "/estoque",
    name: "Estoque",
    component: () => import("@/pages/EstoquePage.vue"),
    meta: {
      menu: true,
      label: "Estoque",
      icon: "Package",
      grupo: "gestao",
      funcionalidade: "estoque",
    },
  },
  {
    path: "/combos",
    name: "Combos",
    component: () => import("@/pages/CombosPage.vue"),
    meta: {
      menu: true,
      label: "Combos",
      icon: "Layers",
      grupo: "gestao",
      funcionalidade: "combos",
    },
  },
  {
    path: "/cupons",
    name: "Cupons",
    component: () => import("@/pages/CuponsPage.vue"),
    meta: {
      menu: true,
      label: "Cupons",
      icon: "Ticket",
      grupo: "gestao",
      funcionalidade: "cupons",
    },
  },
  {
    path: "/servicos",
    name: "Servicos",
    component: () => import("@/pages/Configuracoes/PetShopServico.vue"),
    meta: {
      menu: true,
      label: "Serviços",
      icon: "Scissors",
      grupo: "gestao",
      funcionalidade: "servicos",
    },
  },
  {
    path: "/servicos/novo",
    name: "ServicosNovo",
    component: () => import("@/views/FormularioServico.vue"),
    meta: {
      menu: false,
      funcionalidade: "servicos",
    },
  },
  {
    path: "/servicos/:id",
    name: "ServicosEditar",
    component: () => import("@/views/FormularioServico.vue"),
    meta: {
      menu: false,
      funcionalidade: "servicos",
    },
  },
  {
    path: "/promocoes",
    name: "Promocoes",
    component: () => import("@/pages/Configuracoes/PromocoesPage.vue"),
    meta: {
      menu: true,
      label: "Promoções",
      icon: "Tag",
      grupo: "gestao",
      funcionalidade: "promocoes",
    },
  },
  // 🌐 Portal público do Tutor (sem autenticação)
  {
    path: "/portal/:cnpj",
    name: "PortalAgendamento",
    component: () => import("@/pages/Portal/PortalAgendamentoPage.vue"),
    meta: { menu: false, publico: true },
  },
  {
    path: "/portal/:cnpj/historico",
    name: "PortalHistorico",
    component: () => import("@/pages/Portal/PortalHistoricoPage.vue"),
    meta: { menu: false, publico: true },
  },
  {
    path: "/portal/:cnpj/avaliar",
    name: "PortalAvaliacao",
    component: () => import("@/pages/Portal/PortalAvaliacaoPage.vue"),
    meta: { menu: false, publico: true },
  },
  {
    path: "/erro",
    name: "Erro",
    redirect: "/login",
    meta: { menu: false },
  },

  // 🔧 Rotas de Configurações
  {
    path: "/configuracoes",
    component: ConfiguracoesLayoutBase,
    meta: { menu: true, icon: Settings },
    children: [
      {
        path: "dados-petshop",
        name: "ConfigEmpresa",
        component: () => import("@/pages/Configuracoes/PetShopDados.vue"),
        meta: {
          label: "Dados da Empresa",
        },
      },
      {
        path: "horarios-funcionamento",
        name: "ConfigHorarios",
        component: () =>
          import("@/pages/Configuracoes/HorarioFuncionamento.vue"),
        meta: {
          label: "Horários de Funcionamento",
        },
      },
      {
        path: "linkAgendamentos",
        name: "LinkAgendamentos",
        component: () => import("@/pages/Configuracoes/LinkAgendamento.vue"),
        meta: {
          label: "Link de Agendamentos",
        },
      },
      {
        path: "parametros-empresa",
        name: "ConfigParametrosEmpresa",
        component: () => import("@/pages/Configuracoes/ParametrosEmpresa.vue"),
        meta: {
          label: "Parâmetros da Empresa",
        },
      },
      {
        path: "FaleConosco",
        name: "ConfigFaleConosco",
        component: () => import("@/pages/Configuracoes/FaleConosco.vue"),
        meta: {
          label: "Fale Conosco",
        },
      },
      {
        path: "cupons",
        name: "ConfigCupons",
        component: () => import("@/pages/Configuracoes/CuponsPage.vue"),
        meta: {
          label: "Cupons de Desconto",
        },
      },
      {
        path: "financeiro",
        name: "ConfigFinanceiro",
        component: () => import("@/pages/Configuracoes/FinanceiroPage.vue"),
        meta: {
          label: "Financeiro / Recebimentos",
        },
      },
      {
        path: "assinatura",
        name: "MinhaAssinatura",
        component: () => import("@/pages/Configuracoes/AssinaturaPage.vue"),
        meta: {
          label: "Minha Assinatura",
          funcionalidade: null,
        },
      },
      {
        path: "boost",
        name: "BoostVisibilidade",
        component: () =>
          import("@/pages/Configuracoes/BoostVisibilidadePage.vue"),
        meta: {
          label: "Boost de Visibilidade",
          funcionalidade: null,
        },
      },
      {
        path: "contrato",
        name: "MeuContrato",
        component: () => import("@/pages/Configuracoes/ContratoPage.vue"),
        meta: {
          label: "Meu Contrato",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(), // pode trocar por createWebHashHistory() em dev
  routes,
});

// Guard global — autenticação e carregamento de dados da empresa
router.beforeEach((to, from, next) => {
  const store = useGlobalStore();

  // Restaurar cnpjLogado do localStorage caso o store tenha sido resetado (ex: reload da página)
  if (!store.cnpjLogado) {
    const cnpjSalvo = localStorage.getItem("cnpj_logado");
    if (cnpjSalvo) {
      store.definirCnpjLogado(cnpjSalvo);
    }
  }

  const loggedIn = !!store.cnpjLogado;

  // Rotas públicas (portal do tutor, cadastro, sucesso) — sem autenticação
  if (to.meta?.publico || to.meta?.public) return next();

  // Não logado indo para login → permite sem passar pelo middleware
  if (!loggedIn && to.path === "/login") return next();

  // Não logado tentando acessar rota protegida
  if (!loggedIn && to.path !== "/login") return next("/login");

  // Logado tentando acessar login → redireciona para início
  if (loggedIn && to.path === "/login") return next("/inicio");

  // Detectar conta nova: se há um CNPJ de onboarding pendente que bate com o logado,
  // redirecionar para o onboarding (exceto se já está no onboarding)
  if (loggedIn && to.path !== "/onboarding") {
    const onboardingCnpj = localStorage.getItem("onboarding_pending_cnpj");
    if (onboardingCnpj && onboardingCnpj === store.cnpjLogado) {
      return next("/onboarding");
    }
  }

  // Para rotas protegidas, carregar dados da empresa se necessário.
  // O guard de funcionalidade é verificado DEPOIS de carregar os dados.
  carregarDadosDoMenu(to, from, (resultado) => {
    // Se carregarDadosDoMenu redirecionou, respeitar
    if (resultado !== undefined) return next(resultado);

    // Verificar se a rota exige uma funcionalidade do plano
    const funcChave = to.meta?.funcionalidade;
    if (funcChave && !store.temFuncionalidade(funcChave)) {
      // Redireciona para o início; evita loop se /inicio também estiver bloqueado
      return to.path === "/inicio" ? next() : next("/inicio");
    }

    next();
  });
});

export default router;
